import {
    frequencyValueFromRecurrence,
    getRecurrenceOptions,
    recurrenceFromFrequencyValue,
} from '@common/react/transactions';
import { Recurrence } from '@common/types';
import { parseDate } from '@internationalized/date';
import { FlexCol } from '../common/Flex';
import InputField from '../common/InputField';
import TransactionCardLayout, {
    TransactionCardLayoutProps,
} from './TransactionCardLayout';

export interface TransactionSchedulingCardProps
    extends TransactionCardLayoutProps {
    title: string;
    subtitle: string;
    includeJustOnceOption: boolean;
    recurrence: Recurrence | undefined;
    onChangeRecurrence: (recurrence: Recurrence | undefined) => void;
    date: string | undefined;
    onChangeDate: (date: string) => void;
    minDate: string; // eg '2025-01-01'
    onBack?: VoidFunction;
    onNext: VoidFunction;
    onClose: VoidFunction;
}

const TransactionSchedulingCard = ({
    title,
    subtitle,
    includeJustOnceOption = true,
    recurrence,
    onChangeRecurrence,
    date,
    onChangeDate,
    minDate,
    onBack,
    onNext,
    onClose,
    ...props
}: TransactionSchedulingCardProps) => {
    return (
        <TransactionCardLayout
            {...props}
            title={title}
            subtitle={subtitle}
            onBack={onBack}
            onNext={onNext}
            onClose={onClose}
        >
            <FlexCol pt={8} gap={6}>
                <InputField
                    type="fancySelect"
                    name="recurrence"
                    fancySelectOptions={{
                        isClearable: false,
                        menuWidth: '100%',
                    }}
                    value={frequencyValueFromRecurrence(recurrence)}
                    onChange={(option) => {
                        onChangeRecurrence(
                            recurrenceFromFrequencyValue(option.value)
                        );
                    }}
                    options={getRecurrenceOptions({
                        includeJustOnceOption,
                        includeQuarterlyOption: true,
                    })}
                />
                <InputField
                    type="date"
                    name="date"
                    inputProps={{
                        size: 'md',
                        variant: 'outline',
                    }}
                    labelProps={{
                        fontFamily: 'mono',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        mb: 3,
                    }}
                    label={'STARTING ON'}
                    value={date}
                    onChange={onChangeDate}
                    dateOptions={{
                        minValue: parseDate(minDate),
                    }}
                />
            </FlexCol>
        </TransactionCardLayout>
    );
};

export default TransactionSchedulingCard;
